/** Session-token + Vite-env presentation for /settings. Never log secrets. */

export const SESSION_TOKEN_MASK_PREFIX = '••••';

export function sessionTokenLast4(token?: string | null): string | null {
  if (typeof token !== 'string') return null;
  const trimmed = token.trim();
  if (!trimmed) return null;
  return trimmed.slice(-4);
}

export function maskSessionToken(token?: string | null): string {
  const last4 = sessionTokenLast4(token);
  if (!last4) return 'not set';
  return `${SESSION_TOKEN_MASK_PREFIX}${last4}`;
}

export type ViteEnvDisplay = {
  name: string;
  baked: boolean;
  value: string | null;
  display: string;
  note: string;
};

const RUNTIME_FALLBACKS: Record<string, string> = {
  VITE_API_BASE: '/api',
  VITE_CP_BASE: '/cp',
};

export function formatViteEnvDisplay(
  name: string,
  raw: unknown,
  runtimeFallback?: string,
): ViteEnvDisplay {
  const value = typeof raw === 'string' && raw.trim() ? raw.trim() : null;
  const fallback = runtimeFallback ?? RUNTIME_FALLBACKS[name];
  if (value) {
    return {
      name,
      baked: true,
      value,
      display: value,
      note: 'build-time Vite value',
    };
  }
  if (fallback) {
    return {
      name,
      baked: false,
      value: null,
      display: 'not set',
      note: `runtime fallback ${fallback} (same-origin; not baked into this bundle)`,
    };
  }
  return {
    name,
    baked: false,
    value: null,
    display: 'not set',
    note: 'not baked into this bundle',
  };
}

export function presentViteEnvVars(env: {
  VITE_API_BASE?: unknown;
  VITE_CP_BASE?: unknown;
  VITE_CDN_BASE?: unknown;
}): ViteEnvDisplay[] {
  return [
    formatViteEnvDisplay('VITE_API_BASE', env.VITE_API_BASE, '/api'),
    formatViteEnvDisplay('VITE_CP_BASE', env.VITE_CP_BASE, '/cp'),
    formatViteEnvDisplay('VITE_CDN_BASE', env.VITE_CDN_BASE),
  ];
}
